import React from 'react';

const IconMarkerFav = ({ onClick }) => {
	return (
		<div className='IconMarkerFav' onClick={onClick}>
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_137_2654)">
					<circle cx="10" cy="10" r="10" fill="white" />
					<path fillRule="evenodd" clipRule="evenodd" d="M4.16675 7.49984C4.16675 4.27484 6.77508 1.6665 10.0001 1.6665C13.2251 1.6665 15.8334 4.27484 15.8334 7.49984C15.8334 11.8748 10.0001 18.3332 10.0001 18.3332C10.0001 18.3332 4.16675 11.8748 4.16675 7.49984ZM9.42008 11.4244L10.0001 11.9998L10.5801 11.4287L10.5959 11.4131C12.647 9.38153 14.0001 8.0414 14.0001 6.39766C14.0001 5.05488 13.0321 3.99984 11.8001 3.99984C11.1041 3.99984 10.4361 4.35297 10.0001 4.91101C9.56408 4.35297 8.89608 3.99984 8.20008 3.99984C6.96808 3.99984 6.00008 5.05488 6.00008 6.39766C6.00008 8.04426 7.35785 9.38619 9.41501 11.4194L9.42008 11.4244Z" fill="#C83939" />
				</g>
				<defs>
					<clipPath id="clip0_137_2654">
						<rect width="20" height="20" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</div>
	)
}

export default IconMarkerFav;